import PlinkoMiniGameHandler from 'System/Plinko/Handler/PlinkoMiniGameHandler';
import BaseUISystem from './BaseUISystem';
import DataConflictsMenuHandler from './Menu/DataConflictsMenuHandler';
import GBCDisconnectedMenuHandler from './Menu/GBCDisconnectedMenuHandler';
import { QuitPlinkoMinigamePopup } from './Menu/QuitPlinkoMinigamePopup';

export default class PlinkoUISystem extends BaseUISystem {
    public init(): void {
        this.handlers = [
            // TODO: Plinko add needed handlers
            new PlinkoMiniGameHandler({ system: this }),
            new QuitPlinkoMinigamePopup(this),
            new GBCDisconnectedMenuHandler(this),
            new DataConflictsMenuHandler(this),
        ];
    }
}
